import React from 'react';

import DomUtils from '../../common/utils/DomUtils';

import PropertyPageView from '../../common/controls/PropertyPageView';
import TileView from '../../common/controls/TileView';

import CounterpartyTile from './views/CounterpartyTile';
import CounterpartyView from './views/CounterpartyView';

import './CounterpartiesView.css';

export default class CounterpartiesView extends PropertyPageView {
  constructor(props) {
    super(props);

    this.viewRootElementId = `PwxCounterpartiesView_${crypto.randomUUID()}`;

    this.viewRootElement = null;
    this.parentElement = null;
    this.resizeObserver = null;
  }

  getIntegratedPropertyNames() {
    return [
      'imageMimeTypes',
      'counterparties',
      'selectedCounterparty'
    ];
  }

  componentDidMount() {
    this.viewRootElement = document.getElementById(this.viewRootElementId);
    this.parentElement = this.viewRootElement.parentElement;

    this.resizeObserver = new ResizeObserver(() => requestAnimationFrame(() => this.updateViewHeight()));
    this.resizeObserver.observe(this.parentElement);

    this.updateViewHeight();
  }

  componentWillUnmount() {
    if (this.resizeObserver !== null) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }

    this.parentElement = null;
    this.viewRootElement = null;
  }

  render() {
    return (
      <table id={this.viewRootElementId} className="pwx-counterparties-view">
        <tbody><tr>
          <td id={this.counterpartyListElementId} className="pwx-counterparty-list" valign="top">
            <TileView
              keyExpr="key"
              itemsSource={this.state.counterparties}
              onSelectionChanged={this.onCounterpartySelectionChanged.bind(this)}
              renderTile={counterparty => (<CounterpartyTile key={counterparty.key} counterparty={counterparty} />)}
              selectedItem={this.state.selectedCounterparty}
              tileStyle="pwx-tile-border"
              title="COUNTERPARTIES"
              selectedTileStyle="pwx-tile-border-selected"
              sortField="code"
              spacerStyle="pwx-tile-spacer"
            />
          </td>
          <td valign="top">
            <CounterpartyView counterparty={this.state.selectedCounterparty} imageMimeTypes={this.state.imageMimeTypes} />
          </td>
        </tr></tbody>
      </table>
    );
  }

  updateViewHeight() {
    if (this.parentElement === null)
      return;

    var viewHeight = DomUtils.calculateInnerContentHeight(this.parentElement);

    DomUtils.setElementMaxHeight(this.viewRootElement, viewHeight);

    DomUtils.setElementMaxHeight(
      DomUtils.getElementItemByClassNames('pwx-counterparty-list', 'pwx-tile-container'),
      viewHeight
    );

    DomUtils.setElementMaxHeight(
      DomUtils.getElementItemByClassName('pwx-counterparty-view-container'),
      viewHeight
    );

    DomUtils.setElementMaxHeight(
      DomUtils.getElementItemByClassNames('pwx-contract-list', 'pwx-tile-container'),
      viewHeight
    );

    DomUtils.setElementMaxHeight(
      DomUtils.getElementItemByClassName('pwx-contract-view-container'),
      viewHeight
    );
  }

  onCounterpartySelectionChanged(item) {
    this.dataModel.onCounterpartySelectionChanged(item);
  }
}